import styles from './SortableHeader.module.css';

interface SortableHeaderProps<K extends string = string> {
  label: string;
  sortKey: K;
  currentSort?: { key: K; direction: 'asc' | 'desc' };
  onSort: (key: K) => void;
  align?: 'left' | 'right';
  width?: string;
}

export function SortableHeader<K extends string = string>({
  label,
  sortKey,
  currentSort,
  onSort,
  align = 'left',
  width,
}: SortableHeaderProps<K>) {
  const isActive = currentSort?.key === sortKey;
  const isAsc = isActive && currentSort?.direction === 'asc';
  const isDesc = isActive && currentSort?.direction === 'desc';

  const ariaSort = isAsc
    ? ('ascending' as const)
    : isDesc
      ? ('descending' as const)
      : ('none' as const);

  return (
    <th
      className={styles.header}
      style={{ width, textAlign: align }}
      aria-sort={ariaSort}
      data-testid="sortable-header"
    >
      <button
        type="button"
        className={`${styles.button} ${align === 'right' ? styles.alignRight : ''}`}
        onClick={() => onSort(sortKey)}
      >
        <span>{label}</span>
        <svg className={styles.sortIcon} viewBox="0 0 10 14" aria-hidden="true">
          <path d="M5 0L10 5H0z" className={isAsc ? styles.active : ''} />
          <path d="M5 14L0 9h10z" className={isDesc ? styles.active : ''} />
        </svg>
      </button>
    </th>
  );
}
